module.exports = __webpack_public_path__ + "img/carshina21_19.f7108f43.jpg";